// extracted by mini-css-extract-plugin
export default {"radio":"src-components-common-Radio-radio-module__radioCYIY_","radio-type-negative":"src-components-common-Radio-radio-module__radio-type-negativesdUtK"};